import { DateTimePicker } from '@ts/components/DateTimePicker';
import IMask from 'imask';

export const init = () => {
    setHTMXListeners();
    setInteractiveElements();
}

const setInteractiveElements = () => {
    setDatePickers();
}

const setHTMXListeners = () => {
    document.body.addEventListener('htmx:afterSettle', setInteractiveElements);
    document.body.addEventListener('htmx:historyRestore', setInteractiveElements);
}

const setDatePickers = () => {
    const startDate = document.getElementById("StartDate");
    const endDate = document.getElementById("EndDate");

    const startDatePicker = DateTimePicker.create(startDate, {
        allowInput: true,
        onChange: function (selectedDates, dateStr, fp) {
            const endDatePicker = DateTimePicker.getPicker("EndDate");
            const currentEndDate = endDatePicker.getDate();
            if (currentEndDate && selectedDates[0] >= currentEndDate) {
                const newMinEndDate = new Date(selectedDates[0]);
                newMinEndDate.setDate(newMinEndDate.getDate() + 10);
                endDatePicker.setDate(newMinEndDate);
            }
        }
    }) ?? [];

    const endDatePicker = DateTimePicker.create(endDate, {  
        allowInput: true, 
        onOpen: function(dObj, dStr, fp, dayElem){
            const startDatePicker = DateTimePicker.getPicker("StartDate");

            if (startDatePicker.getDate()) {
                const currentStartDate = startDatePicker.getDate();
                const newMinEndDate = new Date(currentStartDate);
                newMinEndDate.setDate(newMinEndDate.getDate() + 1);
                fp.set('minDate', newMinEndDate);
            }
        }
    }) ?? [];
}